/**
 *
 * @param {ru.hulkmoto.IDateRange} dateRange
 */
export const getApplicableDays = (dateRange, startDate,endDate) => {
 const{
  startMonth,startYear,
 }=dateRange
 let applicable = 0
 if(!startDate || !endDate) return applicable
 let d = startDate
 while (d < endDate) {
  const date= new Date(startYear, startMonth, d)
  const day = date.getDay()
  if ([1,2,3,4,5,6,7].includes(day)) {
   applicable++
  }
  d++
 }
 return applicable
}